// src/components/Magazine/Michelangelo.js
import React, {useState} from 'react';
import CloseIcon from '@mui/icons-material/Close';

import '../styles/magazineGallery.scss';

function Press() {
  /*Costruire react things */
  const data = [
    {
      id: 1,
      imgSrc: '/images/Papers/ElisaPress.jpg',
    },
    {
      id: 2,
      imgSrc: '/images/Papers/Cosmopolitan_Press.jpg',
    },
    {
      id: 3,
      imgSrc:'/images/Papers/MeganPress_1.PNG',
    },
  {
      id: 4,
      imgSrc:'/images/Papers/LowrahPress_1.jpg',
    },
    {
      id: 5,
      imgSrc:'/images/Papers/MeganPresss.jpeg',
    },
    {
        id: 6,
      imgSrc:'/images/Papers/MeganPress_2.PNG',
    },
    {
      id: 7,
      imgSrc: '/images/Papers/Elisa_True_CrimeNextGenMagazine.jpg'
    },
    {
      id: 8,
      imgSrc:'/images/Papers/MeganPress_4.PNG',
    },
    {
      id: 9,
      imgSrc:'/images/Papers/MeganPress_5.PNG',
    },
    {
      id: 10,
      imgSrc:'/images/Papers/MeganPress_6.PNG',
    },
    { id: 11,
      imgSrc:'/images/Papers/MeganPress_7.PNG',
    },
    { id: 12,
      imgSrc:'/images/Papers/MeganPress_8.PNG',
    },
    {
      id: 13,
      imgSrc:'/images/Papers/MeganPress_9.PNG',
    },
    {
      id: 14,
      imgSrc: '/images/Papers/MeganPress_4.PNG',
    },
    {
      id: 15,
      imgSrc: '/images/Papers/GeorgiaNews1.jpg',
    },
    {
      id: 16,
      imgSrc: '/images/Papers/GeorgiaMosNewsReal1.png',
    },
    
    
  ];
    const [model, setModel] = useState(false);
    const [tempimgSrc, setTempImgSrc] = useState('');
    const getImg = (imgSrc) =>{
        setTempImgSrc(imgSrc);
        setModel(true);
    }
  return (
    <>
    <div className={model ? "model open" : "model"}>
        <img src={tempimgSrc} alt="MOB" />
        <CloseIcon onClick={()=> setModel(false)} />
    </div>
        <div className="gallery">
            {[...data].sort((a, b) => a.id - b.id).map((item, index) => {
                return(
                    <div className='pics' key={index} onClick={()=> getImg(item.imgSrc)}>
                        <img src={item.imgSrc} alt="MOB" style={{width: '100%'}} loading="lazy"/>
                    </div>
                )
            })}
        </div>
     
    </>
  );
}

export default Press;
